var render, staticRenderFns
import script from "./computed-storage.vue?vue&type=script&lang=js&"
export * from "./computed-storage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "computed-storage.vue"
export default component.exports